<template>
  <icon-question-filled ref="icon"
                        width="12"
                        height="12"
                        color="#999ca7" />
</template>

<script>
import tippy from 'tippy.js'

export default {
  mounted () {
    tippy(this.$refs.icon.$el, {
      content: 'We\'ll send an email alert a few days before your SSL expires.'
    })
  }
}
</script>
